export default __webpack_public_path__ + "static/media/PPI-walkway-006.8b83a703.jpg";